import React from "react";
import cx from "classnames";
import _ from "lodash";
import styles from "./promptInput.module.scss";

interface PromptInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  visible: boolean;
}

export const PromptInput: React.FC<PromptInputProps> = ({ value, onChange, onSubmit, visible }) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div className={cx(styles.promptInputSection, {[styles.hidden]: !visible})}>
      <div className={styles.promptInputContainer}>
        <form>
          <div className={styles.promptInputBox}>
            <div className={styles.promptInputBorder}>
              <div className={styles.promptInputRow}>
                <label>
                  <textarea
                    className={styles.promptTextarea}
                    name="prompt"
                    style={{ resize: "none" }}
                    placeholder="/Ask anything"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <button
                    type="button"
                    className={cx(styles.submitButton, {
                      [styles.submitButtonActive]: _.size(value) > 0,
                    })}
                    onClick={onSubmit}
                    aria-label="Generate storyboard"
                  >
                    <i className="paperflite-right-arrow" />
                  </button>
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
